// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.scores {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 81px;
    position: relative;
  }

  .box-1 {
    align-items: flex-start;
    background-color: var(--grayscalewhite);
    border-radius: 10px;
    box-shadow: 0px 6px 40px #0076ff1a;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 20px 30px;
    width: fit-content;
  }
  
  .content-2 {
    align-items: center;
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 439px;
  }
  
  .divider {
    height: 60px;
    min-width: 1px;
    position: relative;
  }
  
  
  .number {
    letter-spacing: 0;
    line-height: 36.0px;
    position: relative;
    white-space: nowrap;
    width: fit-content;
  }
  
  .heading-1 {
    left: 0;
    letter-spacing: 0;
    line-height: 30.8px;
    position: absolute;
    top: 0;
    white-space: nowrap;
  }
  
  .potential-scores {
    height: 179px;
    margin-right: -2.00px;
    min-width: 607px;
    position: relative;
  }
  
  .box-2 {
    align-items: flex-start;
    background-color: var(--grayscalewhite);
    border-radius: 10px;
    box-shadow: 0px 6px 40px #0076ff1a;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: hidden;
    padding: 20px 30px;
    width: fit-content;
  }
  
  .content-3 {
    align-items: center;
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 545px;
  }
  
  .divider-1 {
    height: 68px;
    min-width: 1px;
    position: relative;
  }
  
  
  .ellipse-94-1 {
    background-color: var(--accentblue);
    border-radius: 2px;
    height: 4px;
    min-width: 4px;
    position: relative;
  }

  .icon {
    background: linear-gradient(180deg, rgb(0, 95.62, 239.06) 0%, rgb(0, 118.39, 255) 100%);
    border-radius: 1000px;
    height: 48px;
    overflow: hidden;
    width: 48px;
    align-items: center;
    justify-content: center;
  }
  
  .icons-5 {
    height: 24px;
    left: 12px;
    width: 24px;
  }
  
  .frame-255 {
    align-items: center;
    border-radius: 8px;
    display: flex;
    gap: 8px;
    position: relative;
    width: fit-content;
  }
  
  .ellipse-94 {
    background-color: var(--accentblue);
    border-radius: 2px;
    height: 4px;
    min-width: 4px;
    position: relative;
  }
  

  
  .score-number {
    color: var(--grayscaledark-blue);
    font-family: var(--font-family-anek_bangla);
    font-size: var(--font-size-xxl);
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0;
    white-space: nowrap;
    line-height: 36px;
  }
  .score-name{
    color: var(--grayscaleblue-gray-400);
    font-family: var(--font-family-anek_bangla);
    font-size: var(--font-size-s);
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0;
    white-space: nowrap;
    margin-top: -1px;
    line-height: 14px;
  }
  .burea{
    color: var(--grayscaledark-blue);
    font-family: var(--font-family-anek_bangla);
    font-size: var(--font-size-m);
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0;
    white-space: nowrap;
    margin-top: -1px;
    line-height: 25.6px;
  }
  .score-heading{
    color: var(--grayscaledark-blue);
    font-family: var(--font-family-anek_bangla);
    font-size: var(--font-size-xl);
    font-style: normal;
    font-weight: 600;
    margin-bottom: 15px;
  }`, "",{"version":3,"sources":["webpack://./src/components/new/scores/Score.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,uCAAuC;IACvC,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;;EAGA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,OAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,uCAAuC;IACvC,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;;EAGA;IACE,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,uFAAuF;IACvF,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;;;;EAIA;IACE,gCAAgC;IAChC,2CAA2C;IAC3C,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,2CAA2C;IAC3C,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gCAAgC;IAChC,2CAA2C;IAC3C,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gCAAgC;IAChC,2CAA2C;IAC3C,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB","sourcesContent":["\n.scores {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin-top: 81px;\n    position: relative;\n  }\n\n  .box-1 {\n    align-items: flex-start;\n    background-color: var(--grayscalewhite);\n    border-radius: 10px;\n    box-shadow: 0px 6px 40px #0076ff1a;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    padding: 20px 30px;\n    width: fit-content;\n  }\n  \n  .content-2 {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    width: 439px;\n  }\n  \n  .divider {\n    height: 60px;\n    min-width: 1px;\n    position: relative;\n  }\n  \n  \n  .number {\n    letter-spacing: 0;\n    line-height: 36.0px;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n  }\n  \n  .heading-1 {\n    left: 0;\n    letter-spacing: 0;\n    line-height: 30.8px;\n    position: absolute;\n    top: 0;\n    white-space: nowrap;\n  }\n  \n  .potential-scores {\n    height: 179px;\n    margin-right: -2.00px;\n    min-width: 607px;\n    position: relative;\n  }\n  \n  .box-2 {\n    align-items: flex-start;\n    background-color: var(--grayscalewhite);\n    border-radius: 10px;\n    box-shadow: 0px 6px 40px #0076ff1a;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    overflow: hidden;\n    padding: 20px 30px;\n    width: fit-content;\n  }\n  \n  .content-3 {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    width: 545px;\n  }\n  \n  .divider-1 {\n    height: 68px;\n    min-width: 1px;\n    position: relative;\n  }\n  \n  \n  .ellipse-94-1 {\n    background-color: var(--accentblue);\n    border-radius: 2px;\n    height: 4px;\n    min-width: 4px;\n    position: relative;\n  }\n\n  .icon {\n    background: linear-gradient(180deg, rgb(0, 95.62, 239.06) 0%, rgb(0, 118.39, 255) 100%);\n    border-radius: 1000px;\n    height: 48px;\n    overflow: hidden;\n    width: 48px;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .icons-5 {\n    height: 24px;\n    left: 12px;\n    width: 24px;\n  }\n  \n  .frame-255 {\n    align-items: center;\n    border-radius: 8px;\n    display: flex;\n    gap: 8px;\n    position: relative;\n    width: fit-content;\n  }\n  \n  .ellipse-94 {\n    background-color: var(--accentblue);\n    border-radius: 2px;\n    height: 4px;\n    min-width: 4px;\n    position: relative;\n  }\n  \n\n  \n  .score-number {\n    color: var(--grayscaledark-blue);\n    font-family: var(--font-family-anek_bangla);\n    font-size: var(--font-size-xxl);\n    font-style: normal;\n    font-weight: 600;\n    letter-spacing: 0;\n    white-space: nowrap;\n    line-height: 36px;\n  }\n  .score-name{\n    color: var(--grayscaleblue-gray-400);\n    font-family: var(--font-family-anek_bangla);\n    font-size: var(--font-size-s);\n    font-style: normal;\n    font-weight: 500;\n    letter-spacing: 0;\n    white-space: nowrap;\n    margin-top: -1px;\n    line-height: 14px;\n  }\n  .burea{\n    color: var(--grayscaledark-blue);\n    font-family: var(--font-family-anek_bangla);\n    font-size: var(--font-size-m);\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0;\n    white-space: nowrap;\n    margin-top: -1px;\n    line-height: 25.6px;\n  }\n  .score-heading{\n    color: var(--grayscaledark-blue);\n    font-family: var(--font-family-anek_bangla);\n    font-size: var(--font-size-xl);\n    font-style: normal;\n    font-weight: 600;\n    margin-bottom: 15px;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
